import React, { ComponentProps } from 'react';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';

type RoleSettingsDefaultViewProps = {
  manualAssignmentType: 'notRestricted' | 'portalAdmin' | 'systemAdmin' | 'extendedRoleAssignment' | 'notAssignable';
  displayAsContactPerson: boolean;
  searchIsAllowed: boolean;
  qualifier: string;
  inheritablePrivileges: boolean;
  excludeGvp: boolean;
};

export function RoleSettingsDefault(props: RoleSettingsDefaultViewProps) {
  const { t } = useSonTranslation('RoleSettingsForm');

  const getDescription = (key: string, value: string | boolean | undefined) => {
    if (typeof value === 'boolean') {
      return value ? t('glossary:switchedOn') : t('glossary:switchedOff');
    }

    if (key === 'manualAssignmentType' && value) {
      /* @ts-expect-error typing to general for proper language key validation */
      return t(`inputs.manualAssignmentType.values.${value}`);
    }

    /* @ts-expect-error typing to general for proper language key validation */
    return value || t(`inputs.${key}.values.none`);
  };

  return (
    <dl className="role-settings__description-list role-settings__description-list--widget-padding">
      {Object.entries(props).map(([key, value]) => {
        return (
          <div key={key} className="role-settings__description-container">
            <dt className="role-settings__description-term font-bold-15-19">
              {
                /* @ts-expect-error typing to generic for proper language key validation */
                `${t(`inputs.${key}.label`)}:`
              }
            </dt>
            <dd className="role-settings__description-detail font-regular-15-19">{getDescription(key, value)}</dd>
          </div>
        );
      })}
    </dl>
  );
}

export const RoleSettingsDefaultView = asFetchableView(RoleSettingsDefault);
export type RoleSettingsDefaultView = ComponentProps<typeof RoleSettingsDefault>;
